import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortDatabaseComponent } from './port-database.component';

const routes: Routes = [
  {
    path: '',
    component: PortDatabaseComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortDatabaseRoutingModule {}
